// Local development always uses the test API, regardless of branch or overrides.
// Production builds use the deployment override or the existing production API.
export const EMISSIONS_API_URL =
  process.env.NODE_ENV === "development"
    ? "https://i35x45gyg3.execute-api.eu-west-1.amazonaws.com/dev/emissions"
    : process.env.REACT_APP_EMISSIONS_API_URL?.trim() ||
      "https://5hakdlj5xa.execute-api.eu-west-1.amazonaws.com/dev/emissions";
